import * as types from "../actionTypes";

export const getRequest = id => {
  return {
    type: types.MANAGER_GET_PETTY_CASH_REQUEST,
    id
  };
};
export const getRequestSuccess = data => {
  return {
    type: types.MANAGER_GET_PETTY_CASH_SUCCESS,
    payLoad: data
  };
};
export const getRequestFailure = (error, data) => {
  return {
    type: types.MANAGER_GET_PETTY_CASH_FAILURE,
    payLoad: data,
    error: error
  };
};

export const getItemsRequest = (id, pageNum) => {
  return {
    type: types.MANAGER_GET_PETTY_CASH_ITEMS_REQUEST,
    id,
    pageNum
  };
};
export const getItemsRequestSuccess = data => {
  return {
    type: types.MANAGER_GET_PETTY_CASH_ITEMS_SUCCESS,
    payLoad: data
  };
};
export const getItemsRequestFailure = error => {
  return {
    type: types.MANAGER_GET_PETTY_CASH_ITEMS_FAILURE,
    error: error
  };
};

export const getList = pageNumber => {
  return {
    type: types.MANAGER_GET_LIST_PETTY_CASH_REQUEST,
    pageNumber
  };
};
export const getListSuccess = data => {
  return {
    type: types.MANAGER_GET_LIST_PETTY_CASH_SUCCESS,
    payLoad: data
  };
};
export const getListFailure = error => {
  return {
    type: types.MANAGER_GET_LIST_PETTY_CASH_FAILURE,
    error: error
  };
};

export const getTrashedSequenceList = pageNumber => {
  return {
    type: types.MANAGER_GET_TRASHED_SEQUENCE_REQUEST,
    pageNumber
  };
};
export const getTrashedSequenceSuccess = data => {
  return {
    type: types.MANAGER_GET_TRASHED_SEQUENCE_SUCCESS,
    payLoad: data
  };
};
export const getTrashedSequenceFailure = error => {
  return {
    type: types.MANAGER_GET_TRASHED_SEQUENCE_FAILURE,
    error: error
  };
};

export const getNumberList = pageNumber => {
  return {
    type: types.MANAGER_GET_NUMBER_LIST_PETTY_CASH_REQUEST,
    pageNumber
  };
};
export const getNumberListSuccess = data => {
  return {
    type: types.MANAGER_GET_NUMBER_LIST_PETTY_CASH_SUCCESS,
    payLoad: data
  };
};
export const getNumberListFailure = error => {
  return {
    type: types.MANAGER_GET_NUMBER_LIST_PETTY_CASH_FAILURE,
    error: error
  };
};

export const changeState = (id, func, data) => {
  return {
    type: types.MANAGER_CHANGE_STATE_PETTY_CASH_REQUEST,
    id,
    data,
    func
  };
};
export const changeStateSuccess = data => {
  return {
    type: types.MANAGER_CHANGE_STATE_PETTY_CASH_SUCCESS,
    payLoad: data
  };
};
export const changeStateFailure = data => {
  return {
    type: types.MANAGER_CHANGE_STATE_PETTY_CASH_FAILURE,
    payLoad: data
  };
};

export const getUsersListRequest = data => {
  return {
    type: types.UNDER_MANAGER_CONTROL_USERS_LIST_REQUEST,
    data: data
  };
};
export const getUsersListSuccess = data => {
  return {
    type: types.UNDER_MANAGER_CONTROL_USERS_LIST_SUCCESS,
    payLoad: data
  };
};
export const getUsersListFailure = error => {
  return {
    type: types.UNDER_MANAGER_CONTROL_USERS_LIST_FAILURE,
    error: error
  };
};
